import React from "react";

const ButtonComponent = ({ children, classes, handleOnClick }) => {
  return (
    <button className={`buttonComponent ${classes}`} onClick={handleOnClick}>
      {children}
    </button>
  );
};

export default ButtonComponent;
